angular.module("app").controller("GamesJoinPageController", [
    '$scope',
    'preloadedSkinsList',
    'preloadedSkins',
    'preloadedProvidersAndGames',
    'errorHandler',
    'casinoGameService',
    'preloadedCategories',
    'preloadedProviders',
    'pageStatuses',
    'jackpotTypes',
    '$timeout',
    'logger',
    function ($scope, preloadedSkinsList, preloadedSkins, preloadedProvidersAndGames, errorHandler, casinoGameService, preloadedCategories, preloadedProviders, pageStatuses, jackpotTypes, $timeout, logger) {

        var pendingListRequest,
            currentEnabledGameIds = [];

        $scope.filterOptions = {
            status: pageStatuses[0],
            jackpot: jackpotTypes[0],
            gameType: "all",
            search: "",
            searchByExternal: ""
        };
        var categoryTitleIdMap = {};
        var providerTitleNameMap = {};
        var skinNameIdMap = {};

        $scope.multiSelect = {
            selectedCategories: [],
            selectedSkins: [],
            selectedProviders: [],
            providers: angular.copy(preloadedProviders)
        };
        $scope.multiSelect.categoryTitles = angular.copy(preloadedCategories).map(function (item) {
            categoryTitleIdMap[item.title] = item.id;
            return item.title;
        });
        $scope.multiSelect.providerTitles = angular.copy(preloadedProviders).map(function (item) {
            providerTitleNameMap[item.title] = item.name;
            return item.title;
        });
        $scope.multiSelect.skinTitles = angular.copy(preloadedSkins).map(function (item) {
            var name = "ID:" + item.id + " " + item.name;
            skinNameIdMap[name] = item.id;
            return name;
        });
        $scope.pageStatuses = angular.copy(pageStatuses);

        $scope.skinsList = angular.copy(preloadedSkinsList);
        var allProviders = fetchData(preloadedProvidersAndGames);

        $scope.providers = allProviders.slice();

        $scope.existingQuery = "";

        $scope.jackpotTypes = angular.copy(jackpotTypes);

        $scope.skinsLimit = 0;

        $scope.filterForRemove = function (skin) {
            var item  = getItemFromList($scope.existingQuery, [skin]);
            return (item || item === null)
        };

        $scope.add = function (item) {
            item.switchEnabled = true
        };

        $scope.remove = function (item) {
            item.switchEnabled = false
        };

        $scope.toggleProviderGamesActivity = function (item, games) {
            for (var i = games.length; i--;) {
                games[i].switchEnabled = item.switchEnabled;

                $scope.setCurrentActive(games[i], games, item, item.switchEnabled);
            }
        };


        $scope.setCurrentActive = function (game, groupGames, groupsParent, forced) {
            var index = currentEnabledGameIds.indexOf(game.id);

            if (game.switchEnabled && index == -1) {
                currentEnabledGameIds.push(game.id)
            } else if (index != -1 && !game.switchEnabled) {
                currentEnabledGameIds.splice(index, 1)
            }

            var enabledCount = 0;
            for (var i = 0, length = groupGames.length; i < length; i++) {
                groupGames[i].switchEnabled && (enabledCount++);
            }
            groupsParent.switchEnabled = (enabledCount == length && enabledCount != 0) || !!forced

        };

        $scope.save = function () {
            var skins = [];

            for (var i = 0, length = $scope.skinsList.length; i < length; i++) {
                if ($scope.skinsList[i].switchEnabled) {
                    skins.push($scope.skinsList[i].id)
                }
            }

            if (!skins.length) {
                return errorHandler("Skins missing")
            }


            if (!currentEnabledGameIds.length) {
                return errorHandler("Games not selected")
            }

            var requestData = {
                game_ids: currentEnabledGameIds,
                skin_ids: skins
            };

            if ($scope.multiSelect.selectedSkins.length > 0) {
                requestData.use_game_ordering_of_skin = skinNameIdMap[$scope.multiSelect.selectedSkins[0]];
            }

            casinoGameService.joinSkinsGames({joinSkinsGames: requestData}).then(
                function (response) {
                    if (response.status == "ok") {
                        logger.logSuccess("Data has been successfully saved")
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )

        };

        $scope.refreshGamesList = function () {
            !!pendingListRequest && $timeout.cancel(pendingListRequest);

            pendingListRequest = $timeout(function () {
                var requestData = getFiltersValues();
                updateList(requestData, currentEnabledGameIds);
            }, 300)
        };

        function getItemFromList (filterQuery, list) {
            if (!!filterQuery) {
                for (var i = 0, length = list.length, regex = new RegExp("^" + filterQuery.toLowerCase()); i < length; i++) {
                    if (regex.test(list[i].name.toLowerCase()) || regex.test(list[i].id)) {
                        return true
                    }
                }
            } else {
                return null
            }
            return false
        }

        function checkGameName(game) {
            return game.name.toLowerCase().indexOf($scope.filterOptions.search.toLowerCase()) > -1;
        }

        function checkGameByExternalId(game) {
            return game.extearnal_game_id && game.extearnal_game_id.toString() === $scope.filterOptions.searchByExternal;
        }

        $scope.searchGames = function searchGames() {
            if (!$scope.filterOptions.search && !$scope.filterOptions.searchByExternal) {
                $scope.providers = allProviders.slice();
                return;
            }

            var allProvidersLength = allProviders.length;
            var providers = [];
            for (var i = 0; i < allProvidersLength; ++i) {
                var provider = allProviders[i];
                var games = provider.games.filter(function (game) {
                    if ($scope.filterOptions.search && $scope.filterOptions.searchByExternal) {
                        return  checkGameName(game) && checkGameByExternalId(game);
                    }else if ($scope.filterOptions.search) {
                        return checkGameName(game);
                    } else if ( $scope.filterOptions.searchByExternal) {
                        return checkGameByExternalId(game);
                    } else {
                        return false;
                    }
                });
                if (games.length > 0) {
                    var copyProvider = angular.copy(provider);
                    copyProvider.games = games;
                    providers.push(copyProvider);
                }
            }
            $scope.providers = providers;
        }

        function updateList(requestOptions, currentEnabledIds) {

            casinoGameService.getProvidersGroups(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        allProviders = fetchData(angular.copy(response.groups), currentEnabledIds);
                        $scope.searchGames();
                    } else {
                        errorHandler(response.message);
                    }
                },
                function (response) {
                    errorHandler(response.message);
                }
            );
        }

        function getFiltersValues() {
            var currentFilters = {},
                categories = [],
                skins = [],
                providers = [];

            $scope.multiSelect.selectedSkins.forEach(function (value) {
                skins.push(skinNameIdMap[value])
            });

            $scope.multiSelect.selectedCategories.forEach(function (value) {
                categories.push(categoryTitleIdMap[value])
            });

            $scope.multiSelect.selectedProviders.forEach(function (value) {
                providers.push(providerTitleNameMap[value]);
            });

            currentFilters = {
                status: $scope.filterOptions.status,
                jackpot: $scope.filterOptions.jackpot != jackpotTypes[0] ? $scope.filterOptions.jackpot : '',
                categories: categories,
                providers: providers,
                skin_ids: skins,
                is_mobile: $scope.filterOptions.gameType == 'mobile' ? 1 : ($scope.filterOptions.gameType == 'desktop' ? 0 : undefined)
            };

            !currentFilters.jackpot && (delete currentFilters.jackpot);

            !currentFilters.skin_ids.length && (delete currentFilters.skin_ids);

            !currentFilters.search && (delete currentFilters.search);

            (currentFilters.is_mobile === undefined) && (delete currentFilters.is_mobile);

            return currentFilters
        }

        function fetchData (data, currentEnabledIds) {
            currentEnabledIds = currentEnabledIds || [];

            for (var i = 0, iLength = data.length; i < iLength; i++) {
                if (data[i].hasOwnProperty('switchEnabled') && typeof data[i].switchEnabled == "string") {
                    data[i].switchEnabled = data[i].switchEnabled  == "0" ? false : (data[i].switchEnabled == "1" ? true : false);
                } else {
                    data[i].switchEnabled = !!data[i].switchEnabled || false
                }
                var enabledCount = 0;
                for (var j = 0, jLength = data[i].games.length; j < jLength; j++) {
                    if (data[i].games[j].hasOwnProperty('switchEnabled') && typeof data[i].games[j].switchEnabled == "string") {
                        data[i].games[j].switchEnabled = (data[i].games[j].switchEnabled == "0" ? false : (data[i].games[j].switchEnabled == "1" ? true : false)) || currentEnabledIds.indexOf(data[i].games[j].id) != -1;
                    } else {
                        data[i].games[j].switchEnabled = (!!data[i].games[j].switchEnabled || false) || currentEnabledIds.indexOf(data[i].games[j].id) != -1;
                    }
                    !!data[i].games[j].switchEnabled && (enabledCount++)
                }
                data[i].switchEnabled = enabledCount == jLength;

            }
            return data
        }

        $scope.onFilterSelect
            = $scope.onFilterDeselect
            = $scope.onFilterSelectAll
            = $scope.onFilterDeselectAll
            = function () {
            return $scope.refreshGamesList()
        };
        /**
         * Check is one of childs has checked
         * @param item
         */
        $scope.checkChildren = function (item) {
            var isChecked = false;
            item.games.forEach(function (game) {
                if (game.switchEnabled) {
                    isChecked = true;
                    return;
                }
            });
            return isChecked;
        }

    }
]);
